import React, {
  useState, useEffect,
} from "react";

function TimerCountdown() {
  //1 hour
  const waitingTime = 3600;

  const [countdown, setCountdown] = useState(waitingTime);

  const [stoped, setStoped] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          setStoped(true);
        }
        return prevCountdown - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const hours = Math.floor(countdown / 3600);
  const minutes = Math.floor((countdown % 3600) / 60);
  const seconds = countdown % 60;
  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

  return <>{!stoped ? formattedTime : '00:00:00'}</>;
}

export default TimerCountdown;
